import RentApartments from './components/RentApartments';
import RentCommercials from './components/RentCommercials';
import RentDailyApartments from './components/RentDailyApartments';
import SaleApartments from './components/SaleApartments';
import SaleCommercials from './components/SaleCommercials';
import SaleGarages from './components/SaleGarages';
import SaleLands from './components/SaleLands';

const Search = {
  RentApartments,
  RentCommercials,
  RentDailyApartments,
  SaleApartments,
  SaleCommercials,
  SaleLands,
  SaleGarages
};

module.exports = Search;



// WEBPACK FOOTER //
// ./src/app/Search/index.js